import { render, staticRenderFns } from "./Shot.vue?vue&type=template&id=249a4464&scoped=true&"
import script from "./Shot.vue?vue&type=script&lang=js&"
export * from "./Shot.vue?vue&type=script&lang=js&"
import style0 from "./Shot.vue?vue&type=style&index=0&id=249a4464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a4464",
  null
  
)

export default component.exports